export default __webpack_public_path__ + "static/media/motif8.f2a0ff4b.jpg";